let _$field = null

const valueOf = {
  select: () => {
    if (typeIs.select() == false) return ''
    const selectionOption = _$field.options[_$field.selectedIndex]
    return selectionOption.value
      ? selectionOption.text
      : ''
  },
  radioGroup: () => {
    if (typeIs.radioGroup() == false) return
    const checkedItem = document.querySelector(`input[name='${_$field.getAttribute('name')}']:checked`)
    return checkedItem != null
      ? document.querySelector(`input[name='${_$field.getAttribute('name')}']:checked`).value
      : null
  }
}


const typeIs = {
  select: () => /select/i.test(_$field.nodeName),
  radioGroup: () => {
    const groupName = _$field.getAttribute('name')
    let $groupMembers = document.querySelectorAll(`input[name='${groupName}']`)
    $groupMembers = [...$groupMembers]

    const isRadio = /input/i.test(_$field.nodeName) && /radio/i.test(_$field.type)

    return isRadio && $groupMembers.length > 1
  }
}

const FormField = $field => {
  _$field = $field
  return { valueOf, typeIs }
}
export default FormField



// WEBPACK FOOTER //
// ./js/utils/FormField.js